import { ref } from "vue";
import { defineStore } from "pinia";

export const useUploadStore = defineStore("upload", () => {
  /**
   * @typedef {Object} UploadedFile
   * @property {string} url - 上传后的文件 URL
   * @property {string} name - 文件名称
   */
  /**
   * 上传结果列表
   * @type {import('vue').Ref<UploadedFile[]>}
   */
  const uploadedFileList = ref([]);
  // 是否显示完成上传弹窗
  const isShowUploadDialog = ref(false);
  // 上传状态
  const isUploading = ref(false);
  // 当前上传进度
  const currentProgress = ref(0);
  // 当前上传第几个文件
  const currentUploadIndex = ref(0);
  // 当前上传队列中共有多少文件
  const currentUploadAmount = ref(0);
  // input 元素（接收文件）
  const inputFileElement = ref(null);

  return {
    uploadedFileList,
    isShowUploadDialog,
    isUploading,
    currentProgress,
    currentUploadIndex,
    currentUploadAmount,
    inputFileElement,
  };
});
